<div class="calendar-month-scroller">
    <ul class="months">
        <li class="month all" [class.active]="isShowAll">
            <button mat-raised-button class="transparent-button" (click)="showAllEvents($event)">{{ 'dashboard.seeAll' | translate}}</button>
        </li>
        <!--<li class="divider vertical"></li>-->
        <li *ngFor="let month of months" class="month" [class.active]="month.isActive">
            <button mat-raised-button
                    class="transparent-button"
                    (click)="selectMonth($event, month)"
                    [disabled]="month.disabled">
                {{ month.text | translate}}
            </button>
        </li>
    </ul>
</div>
